import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { __awaiter } from "tslib";
/**
 * 预加载图片
 * @param imageUrl 图片地址
 */

export function preloadImage(imageUrl) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var image = new Image();
              image.referrerPolicy = 'no-referrer';
              image.crossOrigin = 'anonymous';

              image.onload = function () {
                return resolve(image);
              };

              image.onerror = reject;
              image.src = imageUrl;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}